
export const NAME = "WikiLinks";
export const DOMAIN = "https://wikilinks.app";
export const HOW_TO_MESSAGE = "ℹ️ Start typing to reveal linked articles that appear on the current Wikipedia page. Find your way to the final article in as few links as possible!";